import React, { useState, useEffect, useRef } from 'react';
import Icon from 'icon';
import Headline from 'headline';
import s from './dropdown.module.scss';

export default function Dropdown({
  question,
  answer,
  primaryQuestion,
  white,
  ...props
}) {
  if (!question || !answer) return null;
  // State
  const [active, setActive] = useState(false);
  const content = useRef(null);
  const [height, setHeight] = useState(null);

  // Functions
  function updateHeight() {
    // upadtes height
    setHeight(content.current.getBoundingClientRect().height);
  }

  const handleActive = () => {
    updateHeight();
    setActive(prevActive => !prevActive);
  };

  // Effects
  useEffect(() => {
    // sets up listener for resizing window because the height of the content might change.
    window.addEventListener('resize', updateHeight);
    return () => window.removeEventListener('resize', updateHeight);
  }, []);

  const whiteBackgroundClass = white ? s.white : '';

  return (
    <div className={`${s.root} ${whiteBackgroundClass}`}>
      <div className={s.questionWrapper} onClick={handleActive}>
        <Headline
          h6
          center
          primary={primaryQuestion}
          secondary={!primaryQuestion}
          className={`${s.question}`}
          html={question}
        />
        <Icon className={s.icon} icon={active ? 'minus' : 'plus'} />
      </div>
      <div className={s.content} style={{ height: active ? height : '0' }}>
        <div
          className={s.answer}
          dangerouslySetInnerHTML={{ __html: answer }}
          ref={content}
        />
      </div>
    </div>
  );
}
